<script setup lang="ts">
import { ref, computed, nextTick } from 'vue';
import { useHistory } from '@/composables/use-history';

const { historyService, historyData } = useHistory();

const TITLE_MAX_LENGTH = 50;

const titleInput = ref();
const isTitleEditing = ref(false);

defineProps<{
    untitledText: string;
}>();

function handleTitleEdit() {
    isTitleEditing.value = true;
    nextTick(() => {
        titleInput.value.focus();
    });
}

function updateTitle(title: string) {
    historyService.updateTitle(title);
    isTitleEditing.value = false;
}

const title = computed(() => {
    return historyData.value.historyDetailTemp.title;
});

const titleOverLimit = computed(() => {
    return title.value.length >= TITLE_MAX_LENGTH;
});

</script>

<template>
    <div
        class="history-header z-40 flex h-[60px] w-full justify-between bg-white"
    >
        <div class="flex w-full items-center px-10 py-1">
            <div class="flex shrink-0 items-center">
                <slot name="type" />
            </div>
            <div v-if="isTitleEditing" class="relative grow">
                <!-- eslint-disable-next-line vue/html-self-closing -->
                <input
                    ref="titleInput"
                    v-model="historyData.historyDetailTemp.title"
                    :maxlength="TITLE_MAX_LENGTH"
                    class="w-full border-none px-1 pr-12 text-xl font-semibold text-black"
                    @blur="updateTitle(title)"
                />
                <div
                    :class="[
                        'absolute right-1 top-1.5 text-xs',
                        titleOverLimit ? 'text-red-500' : 'text-grey-90',
                    ]"
                >
                    {{ title.length }}/{{ TITLE_MAX_LENGTH }}
                </div>
            </div>

            <div
                v-else
                class="line-clamp-1 w-full cursor-pointer px-1 text-xl font-semibold text-grey-90 hover:bg-grey-20"
                :class="{
                    '!text-black': title,
                }"
                @click="handleTitleEdit"
            >
                {{ title || untitledText }}
            </div>

        </div>

        <div class="mr-4 flex shrink-0 items-center">
            <slot name="suffix" />
        </div>
    </div>
</template>
